import { render, staticRenderFns } from "./gig.vue?vue&type=template&id=0ff6bb0d&scoped=true&"
import script from "./gig.vue?vue&type=script&lang=js&"
export * from "./gig.vue?vue&type=script&lang=js&"
import style0 from "./gig.vue?vue&type=style&index=0&id=0ff6bb0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff6bb0d",
  null
  
)

export default component.exports